
// first 2 characters of tooltip content define the position.  
// l, is left tooltip while b, is bottom tooltip

import React, { useState, useEffect, useContext } from 'react'
import TableBox from './TableBox'
import SelectBox from './SelectBox'
import TextBoxS from './TextBoxS'
// import TextBoxInc from './TextBoxInc'
import './styles/OppTable.css'
import { monthsOptionsList, monthsOptionsListS, appserverURL, getTodayDate } from './Common'
import { redirectBackFromSeasonals } from './Common'
import { UserContext } from './UserContext'
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BsArrowsExpand, BsArrowsCollapse, BsQuestionCircle, BsPencilSquare } from "react-icons/bs";
import { getSelectedIDFromSecuritiesList2 } from './Common'
import Tippy from '@tippyjs/react'
import { userAccessToSelectedSecurity } from './Common'
import { opp_dashboard_dialog_content } from './Common'
import { settings_dialog_content } from './Common'
import { trend_chart_left_gap_days, showChatbotIcon } from './Common'
import jwt_decode from 'jwt-decode'
import { SlSettings } from "react-icons/sl";
import { incrementDate } from './Common'
import { BsFillCircleFill } from "react-icons/bs"
import { TbMessageChatbot, TbMessageChatbotFilled } from "react-icons/tb";


const OppTable = (props) => {


  const selectbox = document.getElementById('securityTypeList');


  const { wpUserLevels, browserH, browserW, rdd, token, globalTextSize, debug, loggedinUser } = useContext(UserContext)

  const [seasonalYearsOptionsList, SetSeasonalYearsOptionsList] = useState([])
  const [partialSeasonalYearsOptionsList, SetPartialSeasonalYearsOptionsList] = useState([])

  // current value of options 3 lists

  const [oppTablePartialYearsSuffix, SetOppTablePartialYearsSuffix] = useState('')
  const [rowSelectedId, SetRowSelectedId] = useState(-1)

  const [availableFilters, SetAvailableFilters] = useState([])

  const [oppListExpanded, SetOppListExpanded] = useState(0) //implementing expand contract button next to opp filter

  const [initialMessage, SetInitialMessage] = useState('Loading ...')

  const [numLongs, SetNumLongs] = useState(0);     // used to show longs vs shorts breakdown on the opp table
  const [numShorts, SetNumShorts] = useState(0);   // used to show longs vs shorts breakdown on the opp table

  const showSecuritiesSelectToolbar = useState(() => {
    if (rdd.isMobile && !rdd.isTablet && browserH < browserW) return true;
    else if (rdd.isMobile && rdd.isTablet && browserH > browserW) {
      return true;
    }
    else return false;

  })


  // find the index number from the value of the selected security.  want to just pass the index number to flask
  // const getSelectedIDFromSecuritiesList = () => {
  //   // console.log('s:',props.selectedSecurity,props.securityTypeList)
  //   for (var i = 0; i < props.securityTypeList.length; i++) {
  //     if (props.securityTypeList[i]['value'] === props.selectedSecurity) break
  //   }
  //   // console.log('i=',i)
  //   return (i)
  // }

  // function getMonth(monthStr) {
  //   let d = monthStr + '-1-01';
  //   return new Date(d).getMonth() + 1
  // }

  // previous getMonth function didn't work on firefox - it was a strange function I wrote couple years ago.  this one works on firefox also
  function getMonth(monthName) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const monthIndex = months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());

    if (monthIndex !== -1) return monthIndex + 1;
    else return -1;

  }
  //-------------------------------------------------------------------------------------------------------
  useEffect(() => { // runs when month is changed - sets meta data for opp selectboxes



    // var id = getSelectedIDFromSecuritiesList()
    var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
    // var url = `${flaskServerIP}/YearsMetaData/${id}/${props.oppTableMonth}?token=${token}` // url to get opportunities from server for current month


    // console.log('meta useEffect ',id)
    // console.log(' props.dayOfTheMonth=', props.dayOfTheMonth)


    let base_y = getTodayDate().substring(0, 4);
    let month = getMonth(props.oppTableMonth);
    let day = props.dayOfTheMonth
    let asURL = appserverURL();
    var url = `${asURL}/YearsMetaData2/${id}/${base_y}/${month}/${day}?token=${token}`


    console.log('meta url =', url)
    //////////////////////////////////////////
    // console.log('SetSeasonalYearsOptionsList([]) andSetPartialSeasonalYearsOptionsList([])')
    SetSeasonalYearsOptionsList([])
    SetPartialSeasonalYearsOptionsList([])

    if (token.length > 0) {

      // this didn't work in app.js when tested on trxstat.com - hopefully works here 
      let decoded = jwt_decode(token);
      let show_sr2_token = decoded['show_sr2'];
      if (show_sr2_token === 1) {
        props.SetShowSR2(true);
      }


      fetch(url) //meta 
        .then(res => {
          // console.log('meta res=', res.status)
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          }
          else if (res.status === 429) { // too many requests
            // let trigger = res.headers.get("trigger");
            // props.SetDialogType('info-box'); //429
            props.SetDialogType('rate-limit'); //429
            // props.SetDialogProp({ title: 'Too Many Requests', contentText: ratelimitMessage(trigger, loggedinUser), button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            props.SetInfoBoxVisible(true)
          }
          else {
            console.log('response status = ', res.status)
          }
        })
        .then((oppYearsLists) => {

          // console.log('oppYearsLists=', oppYearsLists)

          if (oppYearsLists !== undefined) {


            // console.log("oppYearsLists['YearsMetaData']=",oppYearsLists['YearsMetaData'] )

            // console.log('yearsmetadata=',yearsMetaData)

            props.SetYearsMetaData(oppYearsLists['YearsMetaData'])

            var years = oppYearsLists['YearsMetaData'].map((item) => {
              return parseInt(item[0])
            })





            years = [...new Set(years)] // unique set of years available

            // console.log('years=',years)

            years.sort((a, b) => { return (a - b) }) //sort

            // console.log('years=',years)

            var tmp = []

            for (var i = 0; i < years.length; i++) {
              tmp.push({ id: years[i], value: years[i].toString(), label: years[i].toString() })
            }

            // console.log('tmp=',tmp)

            SetSeasonalYearsOptionsList(tmp)
            SetRowSelectedId(-1); //reset the selected row

            props.dayOfMonthList(props.oppTableMonth)



            // duplicated it here because sometimes partial years didn't show - now its in this useEffect and the next one
            var tmp = [];
            for (var i = 0; i < oppYearsLists['YearsMetaData'].length; i++)
              if (oppYearsLists['YearsMetaData'][i][0] === props.oppTableYears) tmp.push({ id: oppYearsLists['YearsMetaData'][i][1], value: oppYearsLists['YearsMetaData'][i][1], label: oppYearsLists['YearsMetaData'][i][1] })
            SetPartialSeasonalYearsOptionsList(tmp.sort())

          }

        })
        .catch(err => {
          console.log('catch login error=', err.message)
        })

    }



    SetOppListExpanded(0); // 1/21/2023



    // }, [token, props.oppTableMonth, props.opportunities.length])
  }, [token, props.dayOfTheMonth, props.selectedSecurity]) // 11/30/2021

  //-------------------------------------------------------------------------------------------------------
  // runs when years is changed - set the partial year select from metadata 
  // useEffect(() => { if (props.oppTableYears === -1) { props.SetOppTableYears('12'); } }, [props.oppTableYears])

  //-------------------------------------------------------------------------------------------------------
  // this is the current opportunities list loaded from server
  //-------------------------------------------------------------------------------------------------------






  useEffect(() => {




    // console.log('props.dayOfTheMonth=',props.dayOfTheMonth)
    // console.log('props.oppTablePartialYears=',props.oppTablePartialYears)
    // console.log('props.appliedFilter=',props.appliedFilter)
    // console.log('token=',token)
    // console.log('props.selectedSecurity=',props.selectedSecurity.length)
    // console.log('props.opportunities.length=',props.opportunities.length)
    // console.log('props.oppTableYears=',props.oppTableYears)
    // console.log('oppListExpanded=',oppListExpanded)
    // console.log('\n\n\n')



    var tmp = [];
    for (var i = 0; i < props.yearsMetaData.length; i++)
      if (props.yearsMetaData[i][0] === props.oppTableYears) tmp.push({ id: props.yearsMetaData[i][1], value: props.yearsMetaData[i][1], label: props.yearsMetaData[i][1] })

    // console.log('tmp, yearsMetaData=',tmp,props.yearsMetaData)

    SetPartialSeasonalYearsOptionsList(tmp.sort())
    if (tmp.length > 0) {
      // console.log('before if oppTablePartialYears=',props.oppTablePartialYears)
      if (props.oppTablePartialYears === -1) {

        props.SetOppTablePartialYears(tmp[0]['value'])
        // console.log('opptablepartialyears=',props.oppTablePartialYears)

      }
      // console.log('partial years changed:',tmp[0]['value'])
    }

    if ((rdd.isMobile && !rdd.isTablet && browserH > browserW) | (rdd.isMobile && rdd.isTablet && browserH < browserW)) {
      SetOppTablePartialYearsSuffix(` of ${props.oppTableYears} yrs`)
    }
    else SetOppTablePartialYearsSuffix(` of ${props.oppTableYears} years`)



    if (props.selectedSecurity.length > 0 && props.oppTablePartialYears.length > -1 && props.oppTablePartialYears > '0' && props.oppTableYears !== -1 && props.oppTablePartialYears !== -1) {

      let day_range = '-';
      if (dayRange.length > 1) day_range = dayRange

      // var id = getSelectedIDFromSecuritiesList()
      var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
      let asURL = appserverURL()
      var url = `${asURL}/OppList4/${id}/${props.oppTableMonth}/${props.dayOfTheMonth}/${props.oppTableYears}/${props.oppTablePartialYears}/${day_range}/${oppListExpanded}`



      if (props.appliedFilter !== '' & props.appliedFilter !== 'no filter') url += '/' + props.appliedFilter.slice(0, -1) //slice drops the last character
      else url += '/0';


      // props.SetShowActiveOpps(false); // 5/2/2024


      url += '?token=' + token

      if (debug) console.log('opplist4 url: ', url)

      if (token.length > 0 && props.opportunities.length === 0) {

        fetch(url)
          .then(res => {
            const contentType = res.headers.get("content-type");

            if (contentType && contentType.indexOf("application/json") !== -1) {
              return res.json();
            }
            else if (res.status === 429) { // too many requests
              // let trigger = res.headers.get("trigger");
              // props.SetDialogType('info-box'); //429
              props.SetDialogType('rate-limit'); //429
              // props.SetDialogProp({ title: 'Too Many Requests', contentText: ratelimitMessage(trigger, loggedinUser), button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
              props.SetInfoBoxVisible(true)
            }
            else {
              // console.log('opptable fetch url = ', url)
              console.log('response status opptable fetch = ', res.status)
            }
          })
          .then((opps) => {


            if (opps !== undefined) {
              console.log('oooooooooooooopps=', opps)
              if (opps['OppList'].length === 0 || opps['OppList'].includes('-1')) {
                SetInitialMessage('* No Opportunities data for current selection');
              }
              else SetInitialMessage('Loading ...')

              // console.log('opps=', opps)

              var tbl_col_reordered = opps['OppList'].map((row) => {
                // ['date','symbol','days','dir','sharpe_ratio','avg_profit','median_profit','avg_profit2','sharpe_ratio2']

                const newRow = {
                  date: row[0],
                  symbol: row[1],
                  daysOut: parseInt(row[2]) + 1,
                  lOrS: row[3],
                  // median_profit: parseFloat(row[6]),
                  avg_profit: parseFloat(row[5]),
                  sharpe_ratio: parseFloat(row[4]),
                };

                if (props.showSR2) {
                  newRow.avg_profit2 = parseFloat(row[7]);
                  newRow.sharpe_ratio2 = parseFloat(row[8]);
                }

                return newRow;
              });

              // load the active rows if exist
              var tbl_col_reordered_active = opps['OppActiveList'].map((row) => {
                // ['date','symbol','days','dir','sharpe_ratio','avg_profit','median_profit','avg_profit2','sharpe_ratio2']

                const newRow = {
                  date: row[0],
                  symbol: row[1],
                  daysOut: parseInt(row[2]) + 1,
                  lOrS: row[3],
                  // median_profit: parseFloat(row[6]),
                  avg_profit: parseFloat(row[5]),
                  sharpe_ratio: parseFloat(row[4]),
                };

                // if (props.showSR2) {
                //   newRow.avg_profit2 = parseFloat(row[7]);
                //   newRow.sharpe_ratio2 = parseFloat(row[8]);
                // }

                return newRow;
              });




              // check if token was created in the last 10 seconds, if it is , then load the first opp on the current opplist 
              // which is typically by default in S&P 500 - this is only for non loggedin users

              let decoded = jwt_decode(token);
              let exp = decoded['exp']
              let secs_now = Math.floor(Date.now() / 1000);
              // 10800 is 3 hours which is expireation time - if changed in appserver, change here
              let secs_since_token = -(secs_now, exp - secs_now - 10800)

              // console.log('decoded',exp,secs_now,secs_since_token)

              // console.log('-----------------------------rowIndexClicked=',props.rowIndexClicked);

              // if this if statement is removed, first time going to the site will load the first financial instrument on the list S&p500
              if (secs_since_token < 30 && loggedinUser === '0') {

                //---------------------------------------------------------------------------------------------
                // when a non loggedin user goes to site, if less than 10 secs, show 
                // load the first item on list - only initially which mean in first 10 secs
                // only load this opp if there is no query string
                if (props.qparams.length === 0) {
                  let daysOut = opps['OppList'][0][2]
                  daysOut = String(+daysOut + 1)  // incrementing a string.  the + sign in front of daysOut is called the unary plus operator
                  props.SetStartDate(opps['OppList'][0][0]);
                  props.SetSymbol(opps['OppList'][0][1]);
                  props.SetDaysOut(daysOut);
                  props.SetSeasonalYears(props.oppTableYears);


                  let trend_chart_start_date = incrementDate(opps['OppList'][0][0], -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
                  props.SetTrendChartStartDate(trend_chart_start_date)


                  props.SetRowIndexClicked(0);
                }
              }






              // console.log('tbl_col_reordered=',tbl_col_reordered)

              // console.log("opps['AvailableFilters']=", opps['AvailableFilters'])

              props.SetOpportunities(tbl_col_reordered)
              props.SetActiveOpportunities(tbl_col_reordered_active)

              var tmp = []


              if (opps['AvailableFilters'] !== undefined) {

                for (var i = 0; i < opps['AvailableFilters'].length; i++) {
                  if (opps['AvailableFilters'][i] === '0%') tmp.push({ id: 0, value: 'no filter', label: 'no filter' })
                  else
                    tmp.push({ id: i + 1, value: opps['AvailableFilters'][i], label: `filter: ${opps['AvailableFilters'][i]} reached each year` })
                }

                SetAvailableFilters(tmp)

              }

            }

          })
      }
    }
    // }, [props.dayOfTheMonth, props.oppTablePartialYears, props.appliedFilter, token, props.selectedSecurity, props.opportunities.length, props.oppTableYears, yearsMetaData, oppListExpanded]) //removed dependency of oppTableMontha and oppTableYears because oppTablePartialYears will be the last to change
  }, [props.showActiveOpps, props.dayOfTheMonth, props.oppTablePartialYears, props.appliedFilter, token, props.selectedSecurity, props.opportunities, props.activeOpportunities, props.oppTableYears, oppListExpanded]) //removed dependency of oppTableMontha and oppTableYears because oppTablePartialYears will be the last to change

  // 10/27/2021 added dayofthemonth after replacing opplist2 with opplist3
  // 8/22/2021 added length of opportunities array which is better than other dependencies - could probably remove some of the others
  //-------------------------------------------------------------------------------------------------------
  const handlerKeyDown = (event) => {

    let pressed_key = event['key']
    let ci = props.rowIndexClicked;
    let idx = 0;


    return;  // disabling up down arrow selection 

    if (pressed_key !== 'ArrowUp' && pressed_key !== 'ArrowDown') return;


    if (pressed_key === 'ArrowUp') {
      if (ci > 0) idx = ci - 1;
    }
    else if (pressed_key === 'ArrowDown') {
      if (ci < props.opportunities.length - 1) idx = ci + 1
    }

    if (ci !== idx) {
      props.SetRowIndexClicked(idx);
      props.SetStartDate(props.opportunities[idx]['date'])
      props.SetLastPrice(['', 0]) // reset last price 6/23/2022
      props.SetSymbol(props.opportunities[idx]['symbol'])
      props.SetDaysOut(props.opportunities[idx]['daysOut'])
      props.SetSeasonalYears(props.oppTableYears)
      props.SetMonthsAndQtrs('Months & Qtrs')
    }


  }
  //-------------------------------------------------------------------------------------------------------
  const handlerRowClicked = (rowIndex) => (event) => { // this is to handleRowClicked in TableBox

    // when crazy issue is  happening
    if (event.target.parentElement.childNodes[1].innerText.length > 20) { // should be when crazy issue happens
      let contentText = 'An error occured on the browser.  Try selecting the Opportunity again. '

      props.SetDialogType('info-box');
      props.SetDialogProp({ title: 'Browser Error', contentText: contentText, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
      props.SetInfoBoxVisible(true)
      props.SetSymbol('')
      props.SetSeasonalBarChartData([])
      props.SetLineChartYear(0)

      props.SetConsolidatedSeasonalData([])

    }

    else if (props.rowIndexClicked !== rowIndex) { // when crazy issue is not happening

      let refresh_trend_chart = false;  // this is to decide when to refresh trend chart - otherwise trendchart could disappear if refresh when not

      let opp_start_date = event.target.parentElement.childNodes[0].innerHTML;
      //setting the chart meta data values to the clicked row
      props.SetStartDate(opp_start_date);
      // this line seems to sometimes have the table tags in it ! shows up in the symbol location on UI
      props.SetLastPrice(['', 0]) // reset last price 6/23/2022



      props.SetSymbol(event.target.parentElement.childNodes[1].innerHTML)

      props.SetDaysOut(event.target.parentElement.childNodes[2].innerHTML)
      props.SetSeasonalYears(props.oppTableYears)
      props.SetMonthsAndQtrs('Months & Qtrs')




      if (
        props.symbol !== event.target.parentElement.childNodes[1].innerHTML ||
        // props.startDate != event.target.parentElement.childNodes[0].innerHTML ||
        // props.daysOut != event.target.parentElement.childNodes[2].innerHTML ||
        props.seasonalYears !== props.oppTableYears
      ) {
        props.SetConsolidatedSeasonalData([]) //2022-09-27
        let trend_chart_start_date = incrementDate(opp_start_date, -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
        props.SetTrendChartStartDate(trend_chart_start_date)
      }
      props.SetRowIndexClicked(rowIndex);



    }


  }
  //-------------------------------------------------------------------------------------------------------

  //-------------------------------------------------------------------------------------------------------

  const handleExpandContract = (event) => {

    if (props.showActiveOpps === false) { // no % filtering for active opps

      if (props.loggedinUser !== '0') {


        let retArray = userAccessToSelectedSecurity(props.securityTypeList2, props.selectedSecurity)


        if ((wpUserLevels.length === 1 && wpUserLevels[0] === '1') || retArray[0] === 'F') {
          props.SetDialogType('free-register')
          props.SetInfoBoxVisible(true);
          return;
        } //free registered - cannot expand

        else {
          props.SetOpportunities([]) //clear opportunties table becaues there will be a new fetch

          if (oppListExpanded === 0) SetOppListExpanded(1)
          else SetOppListExpanded(0)

        }

      }

      else {
        props.SetDialogType('free-register')
        props.SetInfoBoxVisible(true);
      }
    }

  }

  //-------------------------------------------------------------------------------------------------------
  // this is for the search textbox
  const [curText, SetCurText] = useState('')
  const [dayRange, SetDayRange] = useState('-'); // dash is empty - its used to send the day range to opplist4 `12/2/2023


  //-------------------------------------------------------------------------------------------------------

  const handleOnChange = (event) => {
    const newText = event.target.value.trim();
    SetCurText(newText);

    // Split the filter text by semicolons (if present)
    const segments = newText
      .split(';')
      .map(seg => seg.trim())
      .filter(seg => seg.length > 0);

    let foundDayRange = false;
    let dayRangeVal = '-';  // Use '-' (as per your original logic)

    // Look for exactly one valid day-range filter among the segments, e.g. "10-40"
    for (const seg of segments) {
      // Regex to match "<digits> - <digits>"
      if (/^\d+\s*-\s*\d+$/.test(seg)) {
        const [n1Str, n2Str] = seg.split('-');
        const n1 = parseInt(n1Str.trim(), 10);
        const n2 = parseInt(n2Str.trim(), 10);

        // Check that n1 < n2 and both are valid numbers
        if (!isNaN(n1) && !isNaN(n2) && n2 > n1) {
          foundDayRange = true;
          dayRangeVal = seg;  // e.g., "10-40"
          break;              // Stop after finding the first valid range
        }
      }
    }

    if (foundDayRange) {
      SetDayRange(dayRangeVal);
      // Clear the opportunities so they will refresh or re-fetch
      props.SetOpportunities([]);
    } else {
      SetDayRange('-');
    }
  };

  //-------------------------------------------------------------------------------------------------------
  // let selectFont='1vw'
  // let textInputFont = '1vw'
  // let spanFont = '1vw'

  //   .opp-table-controls {
  //     /* height: 7%; */
  // }

  // .opp-table-search {
  //     /* height: 7%; */

  // }

  // .opp-table {
  //     /* height:72%; */
  // }

  // .opp-filter{
  //     /* height: 7%; */
  //}


  // dynamic styles



  let spanFontSize = globalTextSize
  // let oppTableControlsHeight = '4%'
  let oppTableControlsHeight = '30px' // after chatbot changed from percent to static px

  // let oppTableSearchHeight = '4%'
  let oppTableSearchHeight = '30px'

  // let oppTableHeight = '88%'
  let oppTableHeight = 'calc(100% - 90px)'

  // let oppFilterHeight = '4%'
  let oppFilterHeight = '30px'


  let leftArrowdisplay = 'none'
  // next 4 items are for child divs in the bottom filter
  let expandDivWidth = '5%'
  let selectDivWidth = '35%'
  let spanDivWidth = '55%'
  let leftSpaceDivWidth = '5%'
  let expandIconSize = 20
  let opp_manager_icon_size = 20
  // console.log('browserW=',browserW)

  if (rdd.isMobile) {
    if (rdd.isTablet) {
      if (browserH > browserW) { //portrait
        oppTableControlsHeight = '9%'
        oppTableSearchHeight = '9%'
        oppTableHeight = '73%'
        oppFilterHeight = '9%'
        spanFontSize = globalTextSize

        expandDivWidth = '5%'
        selectDivWidth = '30%'
        spanDivWidth = '30%'
        leftSpaceDivWidth = '35%'
        expandIconSize = 30
        if (browserW >= 1024) {
          expandIconSize = 40;
          opp_manager_icon_size = 40;
        }
        else {
          expandIconSize = 30;
          opp_manager_icon_size = 25;
        }
      }
      else { //landscape
        oppTableControlsHeight = '4%'
        oppTableSearchHeight = '4%'
        oppTableHeight = '88%'
        oppFilterHeight = '4%'
        spanFontSize = globalTextSize

        expandDivWidth = '10%'
        selectDivWidth = '66%'
        spanDivWidth = '25%'
        leftSpaceDivWidth = '0%'

        if (browserH >= 1024) expandIconSize = 30
        else expandIconSize = 20
      }
    }
    else { // smartphone
      if (browserH > browserW) { //portrait
        oppTableControlsHeight = '9%'
        oppTableSearchHeight = '9%'
        oppTableHeight = '73%'
        oppFilterHeight = '9%'
        spanFontSize = globalTextSize
        //filter widths
        expandDivWidth = '10%'
        selectDivWidth = '36%'
        spanDivWidth = '46%'
        leftSpaceDivWidth = '8%'

      }
      else { //landscape
        oppTableControlsHeight = '12%'
        oppTableSearchHeight = '12%'
        oppTableHeight = '64%'
        oppFilterHeight = '12%'
        // spanFontSize = globalTextSize
        leftArrowdisplay = 'inline'

        //filter widths
        expandDivWidth = '5%'
        selectDivWidth = '30%'
        spanDivWidth = '30%'
        leftSpaceDivWidth = '35%'
        expandIconSize = 25
      }
    }
  }



  const oppTableControlsStyle = {
    height: oppTableControlsHeight,
  }
  const oppTableSearchStyle = {
    height: oppTableSearchHeight
  }
  const oppTableStyle = {
    height: oppTableHeight
  }
  const oppFilterStyle = {
    height: oppFilterHeight,
    // backgroundColor:'lightblue'
  }





  const handleForwardClick = () => {
    // props.SetLineChartYear('2020')
    if (rdd.isMobile && !rdd.isTablet && browserH > browserW) {
      props.chartTo(1)
    }
    else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) {
      props.chartTo(1)
    }
    // console.log('here I am')
  }
  const handleBackClick = () => {
    if (rdd.isMobile) {
      redirectBackFromSeasonals();
    }
  }





  const handleHelpClicked = () => {
    // props.SetHelpBoxVisible(!props.helpBoxVisible);
    props.SetVideosBoxVisible(true)
  }
  //-------------------------------------------------------------------------------------------------------
  // turn features on or off on opp controls bar
  let SecuritiesDisplay = 'flex', navDivDisplay = 'flex', questionDisplay = 'flex';
  // if ((rdd.isMobile && browserH > browserW) | !rdd.isMobile | (rdd.isTablet && browserH < browserW)) {
  if ((!rdd.isTablet && rdd.isMobile && browserH > browserW) | !rdd.isMobile | (rdd.isTablet && browserH < browserW)) {
    navDivDisplay = 'none'; // remove nav buttions when portrait smartphone tablet
    questionDisplay = 'none'
  }
  if (!rdd.isMobile | (rdd.isTablet && browserH < browserW)) SecuritiesDisplay = 'none'
  if (!rdd.isMobile) {
    questionDisplay = 'none'
  }


  if (rdd.isMobile && rdd.isTablet && browserH > browserW) { //portrait ipad
    questionDisplay = 'none'
  }

  const StyleNavDiv = {
    // backgroundColor: "gold",
    display: navDivDisplay,
    alignItems: "center",
    height: "100%",
    // marginRight:"7px"
  }

  const StyleBackArrow = {
    // backgroundColor: "red",
    // marginRight: "7px",
    marginLeft: "10px",
    display: leftArrowdisplay,

    alignItems: "center"
  }

  const StyleForwardArrow = {
    // backgroundColor: "rgba(0,152,0,0.8",
    display: "none",
    alignItems: "center",
    marginRight: "7px"
  }

  const StyleoppFilterLeftSpace = {
    width: leftSpaceDivWidth,
    // backgroundColor: 'red'
  }

  const StyleoppFilterExpand = {
    width: expandDivWidth,
  }
  const StyleoppFilterSelect = {
    width: selectDivWidth,
    backgroundColor: 'transparent'
  }
  const StyleoppFilterSpan = {
    width: spanDivWidth,
    backgroundColor: 'transparent'
  }

  const handleSettings = () => {
    if (loggedinUser === '0') {
      props.SetDialogType('info-box');
      props.SetDialogProp({ title: 'Settings', contentText: settings_dialog_content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' });
      props.SetInfoBoxVisible(true);
    }
    else {
      props.SetShowSettings(true);
    }

  }

  const handleDRreport = () => {

    if (loggedinUser === '0') {
      props.SetDialogType('info-box');
      props.SetDialogProp({ title: 'Portfolio Manager', contentText: opp_dashboard_dialog_content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' });
      props.SetInfoBoxVisible(true);
    }

    else {
      props.SetReportsDashVisible(true);
    }

  }

  const marginRight = browserH > browserW ? '8vw' : '2vw';

  //-------------------------------------------------------------------------------------------------------
  return (

    <div className='opp-container' >

      <div className='opp-table-controls' style={oppTableControlsStyle}>

        {/* if on mobile put the security selection pull down in oppTable otherwise its on desktoplayout.js */}
        <div style={{ backgroundColor: "transparent", width: "100%", height: "100%", display: "flex", alignItems: "center" }}>
          <div style={{ backgroundColor: "transparent", height: "100%", width: "20%" }}>
            <div style={StyleNavDiv} >

              <div style={StyleBackArrow} >
                <button className="nav-buttons">
                  <FaAngleLeft size={30} style={{ fill: "white" }} onClick={handleBackClick} />
                </button>
              </div>


              <div style={StyleForwardArrow}>
                <button className="nav-buttons">
                  <FaAngleRight size={20} style={{ fill: "white" }} onClick={handleForwardClick} />
                </button>
              </div>


              {/* {(rdd.isMobile & !rdd.isTablet & browserH < browserW) */}
              {showSecuritiesSelectToolbar
                &&
                <div style={{ marginLeft: '4vw', backgroundColor: "transparent", height: "70%", width: "90%", display: SecuritiesDisplay, justifyContent: "flex-start", alignItems: "center" }}>
                  <SelectBox optionList={props.securityTypeList} name="securityTypeList" value={props.selectedSecurity} sbChanged={props.selectboxChanged} />
                </div>
              }


            </div>
          </div>

        </div>

        {/* mobile portrait clipboard icon */}
        {(rdd.isMobile && !(rdd.isMobile && rdd.isTablet && browserW > browserH)) &&
          <div style={{ display: 'flex', backgroundColor: 'transparent', marginRight: marginRight, marginLeft: '2vw', alignItems: 'center' }}>
            <BsPencilSquare size={opp_manager_icon_size} style={{ fill: "white" }} onClick={handleDRreport} />
            {/* <SlSettings size={opp_manager_icon_size} style={{ fill: "white", marginLeft: '3vw' }} onClick={handleSettings} /> */}

          </div>
        }


        {/* month selection  */}
        {/* mobile portrait takes adavtage of short suffixes */}
        {(rdd.isMobile & rdd.isTablet & browserH < browserW) | (rdd.isMobile & !rdd.isTablet & browserH > browserW)
          ? <div className='opp-table-controls-items' ><SelectBox optionList={monthsOptionsListS} value={props.oppTableMonth} suffix="" name="months" sbChanged={props.selectboxChanged} /></div>
          : <div className='opp-table-controls-items' ><SelectBox tooltipContent={props.tooltipSW ? 'b,Change Opportunities Month to see active trades, for backtesting or future analytis' : ''} optionList={monthsOptionsList} value={props.oppTableMonth} suffix="" name="months" sbChanged={props.selectboxChanged} /></div>
        }

        {/* day of the month 4/29/2022  */}

        <div className='opp-table-controls-items'><SelectBox tooltipContent={props.tooltipSW ? 'b,Change opportunities day of the month to see active trades, for backtesting or future analysis' : ''} optionList={props.daysOfMonthList} value={props.dayOfTheMonth} suffix=" " name="day" sbChanged={props.selectboxChanged} /></div>


        {(rdd.isMobile & !rdd.isTablet & browserH > browserW) | (rdd.isMobile & rdd.isTablet & browserH < browserW)
          ? <div className='opp-table-controls-items'><SelectBox optionList={seasonalYearsOptionsList} value={props.oppTableYears} suffix=" yrs" name="years" sbChanged={props.selectboxChanged} /></div>
          : <div className='opp-table-controls-items'><SelectBox tooltipContent={props.tooltipSW ? 'b,You can change the number of analysis years for the TradeWave opportunities. Current Historical Years Setting  ' + props.oppTableYears + ' years' : ''} optionList={seasonalYearsOptionsList} value={props.oppTableYears} suffix=" years" name="years" sbChanged={props.selectboxChanged} /></div>
        }

        {/* number of years selection  */}
        <div className='opp-table-controls-items' style={{ marginRight: "12px" }} >
          <SelectBox tooltipContent={'r,' + (props.tooltipSW ? 'TradeWave Probability: Select minimum # of years to filter opportunities in the list. This changes the probability of profitability in the list of opportunities. Currently set to : ' : '') + Math.round((100 * parseInt(props.oppTablePartialYears) / parseInt(props.oppTableYears))).toString() + '%'} optionList={partialSeasonalYearsOptionsList} value={props.oppTablePartialYears} suffix={oppTablePartialYearsSuffix} name="partialYears" sbChanged={props.selectboxChanged} />
        </div>

        <div style={{ paddingRight: '0%', display: questionDisplay, width: '10%', alignItems: 'center' }}>
          <BsQuestionCircle size={16} style={{ fill: "white" }} onClick={handleHelpClicked} />
        </div>

      </div>

      <div className='opp-table-search' style={oppTableSearchStyle}>

        {
          (rdd.isMobile & !rdd.isTablet & browserH > browserW)
            ? <div style={{ marginLeft: '4vw', backgroundColor: "transparent", height: "70%", width: "90%", display: SecuritiesDisplay, justifyContent: "flex-start", alignItems: "center" }}>
              <SelectBox optionList={props.securityTypeList} name="securityTypeList" value={props.selectedSecurity} sbChanged={props.selectboxChanged} />
            </div>
            : <div></div>
        }
        {/* ******************************************* */}
        {/* this is for the active opportunities button */}
        {props.activeOpportunities.length > 0 && loggedinUser !== '0' &&

          <Tippy
            placement={'top'}
            content={
              <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                {/* {props.tooltipSW ? 'Premium Feature: By default 1 opportunity is returned per ticker with highest sharpe-ratio. Expand will return every trade for each ticker for the current start date.' : ''} */}
                {props.tooltipSW ? "Click 'Active' to view waves that started within the last 5 days and still fall within the opportunity's date range. Use this to identify which past waves remain viable—such as those with minimal price changes or those moving against the wave's expected direction. This helps refine your analysis and decision-making for active opportunities." : ""}
              </div>
            }
          >

            <div style={{ backgroundColor: "gray", width: '14%', height: '100%', display: 'flex', marginRight: '0.2%', borderTop: '1px solid lightgray', borderBottom: '1px solid white', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => { props.SetShowActiveOpps(!props.showActiveOpps); props.SetAppliedFilter('no filter'); }}   >
              <span className="noselect" style={{ fontWeight: 'bold', fontSize: globalTextSize, color: props.showActiveOpps ? "blue" : "lightgray" }} >Active&nbsp;&nbsp;</span>
              {/* <BsFillCircleFill size={12} style={{ fill: props.showActiveOpps ? "green" : "white" }} /> */}
            </div>
          </Tippy>
        }

        <div className='opp-table-controls-items noselect' >  <span style={{ fontSize: globalTextSize, color: "black" }}  >Filter&nbsp;</span>    </div>
        <div className='opp-table-controls-items' style={{ marginRight: "11px" }} >
          {/* <TextBoxS tooltipContent={props.tooltipSW ? 'b,Search and Filter the Opportunities Table by all cells. \n Days can be filtered by a range of days; to filter a range of 30 to 60 days enter the range in the search as: 30-60.  You can also filter the Sharpe Ratio, (SR) by entering > sign and a number.  For example, enter ">2.0" in the filter text box.  Opportunities table is filtered to show only opportunities with Sharpe Ratio > 2.0 ' : ''} handleOnChange={handleOnChange} curText={curText} name='Filter' /> */}
          <TextBoxS
            tooltipContent={
              props.tooltipSW
                ?
                // Start with 'b,' to set the tooltip position (bottom), then the new instructions:
                'b,Filter the Opportunities Table using multiple conditions separated by semicolons. ' +
                'For a day range of 30 to 60 days, type "30-60". ' +
                'To filter by Sharpe Ratio, type "SR>2". ' +
                'For Average Profit, type "AP>10" or "AVGP>10". ' +
                'You can also do a default text search by typing any keyword, like "AAPL". '
                : ''
            }
            handleOnChange={handleOnChange}
            curText={curText}
            name='Filter'
          />
        </div>

      </div>

      <div className='opp-table' style={oppTableStyle}>
        {
          props.opportunities.length > 0
            ? (
              <TableBox
                table_data={props.showActiveOpps ? props.activeOpportunities : props.opportunities}
                handlerRowClicked={handlerRowClicked}
                handlerKeyDown={handlerKeyDown}
                rowIndexClicked={props.rowIndexClicked}
                SetRowIndexClicked={props.SetRowIndexClicked}
                filterText={curText}
                tooltipSW={props.tooltipSW}
                SetOppTableLength={props.SetOppTableLength}
                showSR2={props.showSR2}
                showAciveOpps={props.showActiveOpps}
                upgradeMessage={props.upgradeMessage}
                promotionMessage={props.promotionMessage}
                promotionCouponCode={props.promotionCouponCode}
                promotionBackColor={props.promotionBackColor}
                showUpgradeBanner={props.showUpgradeBanner}
                SetShowUpgradeBanner={props.SetShowUpgradeBanner}
                SetNumLongs={SetNumLongs}
                SetNumShorts={SetNumShorts}
              />
            )
            : initialMessage
        }
      </div>
      {/* create a visual div below to show a nice box below the above div - inside the div say : to see all opportunities create a free account */}



      <div className='opp-filter' style={oppFilterStyle}>

        <div className='opp-filter-left-space' style={StyleoppFilterLeftSpace} onClick={handleBackClick}  >
          {
            (rdd.isMobile && browserH > browserW) &&
            <FaAngleLeft size={(rdd.isTablet ? 40 : 30)} style={{ fill: "white" }} onClick={handleBackClick} />
          }
          {
            (rdd.isDesktop && showChatbotIcon) &&
            <TbMessageChatbot size={30} style={{ fill: "white" }} onClick={() => { props.SetShowChatbot(!props.showChatbot) }} />
          }
        </div>

        {/* implement the opportunities count and short and long and % below the opp table  */}

        <div className='opp-filter-span' style={StyleoppFilterSpan}>
          {(rdd.isMobile && browserH > browserW) ? (
            // Mobile View: No Tippy
            <span style={{ fontSize: globalTextSize, color: "white" }}>
              {props.oppTableLength} opps&nbsp;
              <span style={{ color: "#ffffff" }}> {numLongs} </span> L &nbsp;
              <span style={{ color: "#ffffff" }}> {numShorts} </span> S
              <span>&nbsp;</span>
              <span
                style={{
                  backgroundColor: numShorts > numLongs ? "red" : "green",
                  color: "white",
                  padding: "0 5px", // Optional for better spacing
                  borderRadius: "4px", // Optional for rounded corners
                }}
              >
                {parseInt(
                  100 *
                  (numShorts > numLongs
                    ? numShorts / (numShorts + numLongs)
                    : numLongs / (numShorts + numLongs)
                  )
                )}
                %
              </span>
            </span>
          ) : (
            // Desktop View: With Tippy
            <span style={{ fontSize: globalTextSize, color: "white" }}>
              <Tippy
                placement={'top'}
                content={
                  <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                    Total # of Opportunities
                  </div>
                }
              >
                <span>{props.oppTableLength} opportunities</span>
              </Tippy>
              &nbsp;
              <Tippy
                placement={'top'}
                content={
                  <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                    Total # of Long Opportunities
                  </div>
                }
              >
                <span style={{ color: "#ffffff" }}> {numLongs} </span>
              </Tippy>
              Longs &nbsp;
              <Tippy
                placement={'top'}
                content={
                  <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                    Total # of Short Opportunities
                  </div>
                }
              >
                <span style={{ color: "#ffffff" }}> {numShorts} </span>
              </Tippy>
              Shorts
              <span>&nbsp;</span>
              <Tippy
                placement={'top'}
                content={
                  <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                    If the indicator is green and shows 60%, it means 60% of all opportunities are Long positions.
                    If the indicator is red and shows 70%, it means 70% of all opportunities are Short positions.
                  </div>
                }
              >
                <span
                  style={{
                    backgroundColor: numShorts > numLongs ? "red" : "green",
                    color: "white",
                    padding: "0 5px",
                    borderRadius: "4px",
                  }}
                >
                  {/* {parseInt(
                    100 *
                    (numShorts > numLongs
                      ? numShorts / (numShorts + numLongs)
                      : numLongs / (numShorts + numLongs)
                    )
                  )} */}
                  {/* this method doesn't show Nan when things are still loading  */}
                  {(() => {
                    const percentage = parseInt(
                      100 *
                      (numShorts > numLongs
                        ? numShorts / (numShorts + numLongs)
                        : numLongs / (numShorts + numLongs)
                      )
                    );
                    return isNaN(percentage) ? '' : `${percentage}%`;
                  })()}

                </span>
              </Tippy>
            </span>
          )}
        </div>




        <div className='opp-filter-select' style={StyleoppFilterSelect} >
          <SelectBox tooltipContent={props.tooltipSW ? 'r,filter by minimum % reached each year' : ''} optionList={availableFilters} value={props.appliedFilter} suffix="" name="filter" sbChanged={props.selectboxChanged} />
        </div>





        <Tippy placement={'right'} content={
          <div style={{ backgroundColor: 'transparent', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
            {props.tooltipSW ? 'Premium Feature: By default 1 opportunity is returned per ticker with highest sharpe-ratio. Expand will return every trade for each ticker for the current start date.' : ''}
          </div>
        }>


          <div className='opp-filter-expand' onClick={handleExpandContract} style={StyleoppFilterExpand}>
            {oppListExpanded === 1
              ? <BsArrowsExpand size={expandIconSize} style={{ fill: "white" }} />
              : <BsArrowsCollapse size={expandIconSize} style={{ fill: "white" }} />
            }
          </div>

        </Tippy>

      </div>


    </div>
  )
}

export default OppTable
